<template>
	<div :class="{ 'hidden': hidden }" class="pagination-container">
		<el-pagination :background="background" :current-page="currentPage" :page-size="pageSize" :layout="layout"
			:page-sizes="pageSizes" :pager-count="pagerCount" :total="total" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script setup>
	// import { scrollTo } from '@/utils/scroll-to'

	const props = defineProps({
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		pageSize: {
			type: Number,
			default: 20
		},
		pageSizes: {
			type: Array,
			default () {
				return [20, 50, 100]
			}
		},
		// 移动端页码按钮的数量端默认值5
		pagerCount: {
			type: Number,
			default: 5 // 5-21之间 document.body.clientWidth < 992 ? 5 : 7
		},
		layout: {
			type: String,
			default: 'prev, pager, next, sizes, jumper'
			// default: 'total, sizes, prev, pager, next, jumper'
		},
		background: {
			type: Boolean,
			default: false
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	})

	const emit = defineEmits()
	const currentPage = computed({
		get() {
			return props.page
		},
		set(val) {
			emit('update:page', val)
		}
	})
	const currentPageSize = computed({
		get() {
			return props.pageSize
		},
		set(val) {
			emit('update:pageSize', val)
		}
	})

	// 限制 pagerCount 范围
	const validPagerCount = computed(() => {
		let count = props.pagerCount
		if (count < 5) count = 5
		if (count > 21) count = 21
		return count
	})

	// 计算最大页码
	const maxPage = computed(() => Math.ceil(props.total / props.pageSize) || 1)

	// 监听 total 或 pageSize 变化，自动修正页码越界
	watch(
		[() => props.total, () => props.pageSize, () => props.page],
		() => {
			const max = maxPage.value
			let newPage = props.page
			if (max > 0 && newPage > max) {
				newPage = max
			} else if (newPage < 1 && max > 0) {
				newPage = 1
			}
			if (newPage !== props.page) {
				emit('update:page', newPage)
				// 可选：触发 pagination 事件告知父组件
				emit('pagination', {
					page: newPage,
					pageSize: props.pageSize
				})
			}
		}
	)

	// 滚动到顶部（可自定义动画）
	const scrollToTop = () => {
		if (props.autoScroll) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	}

	function handleSizeChange(val) {
		// 改变每页条数后，当前页码可能需要重置为1（避免当前页无数据）
		let newPage = currentPage.value
		if (newPage * val > props.total) {
			newPage = 1
		}
		if (newPage !== currentPage.value) {
			currentPage.value = newPage
		}
		currentPageSize.value = val
		
		emit('pagination', {
			page: newPage,
			pageSize: val
		})
		scrollToTop()

		// if (currentPage.value * val > props.total) {
		// 	currentPage.value = 1
		// }
		// emit('pagination', {
		// 	page: currentPage.value,
		// 	pageSize: val
		// })
		
		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}

	function handleCurrentChange(val) {
		currentPage.value = val

		emit('pagination', {
			page: val,
			pageSize: currentPageSize.value
		})

		scrollToTop()
		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}
</script>

<style scoped>
	.pagination-container.hidden {
		display: none;
	}
</style>